import { useAppDispatch, useAppSelector } from "@/config/store";
import { Button } from "@/components/ui";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";
import { IEdoQuiz } from "@/shared/model/edo-quiz.model";
import { deleteEntity } from "@/shared/reducers/entities/edo-quiz.reducer";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { useEffect } from "react";
import { Translate } from "react-jhipster";

interface IDeleteQuizProps {
  quiz: IEdoQuiz;
  open: boolean;
  onClose: () => void;
}

const DeleteQuiz = (props: IDeleteQuizProps) => {
  const dispatch = useAppDispatch();
  const { updateSuccess } = useAppSelector<EntityState<IEdoQuiz>>(
    (state) => state.edoQuiz
  );

  const { quiz, open, onClose: handleClose } = props;

  const confirmDelete = () => {
    dispatch(deleteEntity(quiz.id));
  };

  useEffect(() => {
    if (open && updateSuccess) {
      handleClose();
    }
  }, [updateSuccess, open, handleClose]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && handleClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Translate contentKey="entity.delete.title">
              Confirm delete operation
            </Translate>
          </DialogTitle>
        </DialogHeader>
        <p className="text-body text-[var(--color-mockup-text-mid)]">
          <Translate
            contentKey="edocendoApp.edoQuiz.delete.question"
            interpolate={{ nome: quiz?.title }}
          >
            Are you sure you want to delete this EdoQuiz?
          </Translate>
        </p>
        <DialogFooter className="gap-2 pt-4">
          <Button variant="outline" onClick={handleClose}>
            <Translate contentKey="entity.action.cancel">Cancel</Translate>
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            <Translate contentKey="entity.action.delete">Delete</Translate>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteQuiz;
